import { render, staticRenderFns } from "./SettlementDetailsContainer.vue?vue&type=template&id=208df510&scoped=true"
import script from "./SettlementDetailsContainer.vue?vue&type=script&lang=js"
export * from "./SettlementDetailsContainer.vue?vue&type=script&lang=js"
import style0 from "./SettlementDetailsContainer.vue?vue&type=style&index=0&id=208df510&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208df510",
  null
  
)

export default component.exports